import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "@/lib/content";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#0F1F18] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2">
            <img
              src="/logo.png"
              alt="FB Services logo"
              className="h-14 w-auto object-contain brightness-[1.6] contrast-125"
            />
          </div>
          <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-xs">
            Nettoyage professionnel et entretien d'espaces verts en Provence.
            Une équipe locale, deux savoir-faire.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 font-semibold">
            Services
          </div>
          <ul className="mt-5 space-y-2 text-sm text-white/85">
            <li>Nettoyage copropriété</li>
            <li>Nettoyage bureaux</li>
            <li>Cage d'escalier</li>
            <li>Fin de chantier</li>
            <li>Taille de haie & arbustes</li>
            <li>Débroussaillage & tonte</li>
            <li>Plantation</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-widest text-white/50 font-semibold">
            Contact
          </div>
          <ul className="mt-5 space-y-3 text-sm text-white/85">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-[#D4A373]" />
              <a href={BRAND.phoneHref} data-testid="footer-phone">{BRAND.phone}</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-[#D4A373]" />
              <a href={BRAND.emailHref} data-testid="footer-email">{BRAND.email}</a>
            </li>
            {BRAND.address && (
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-[#D4A373]" />
                <span>{BRAND.address}</span>
              </li>
            )}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/55">
          <div>© {new Date().getFullYear()} FBSERVICES. Tous droits réservés. · SIRET 930 739 875 00019</div>
          <div>Bouc-Bel-Air · Provence-Alpes-Côte d'Azur</div>
        </div>
      </div>
    </footer>
  );
}
